import React, { Component } from 'react';
import { Singleton } from '../../../js/Singleton';
import {  hangUp } from '../../../Images/CallSpaceHeaderSVG';
import AnimatedPhone from '../../Animations/AnimatedPhone';

export default class CallingAssitedTransfer extends Component{
    constructor(props){
        super(props);
        this.language = new Singleton();
        
    }

    render() {
        return (
            <div className="transferringWindow">
                <div className="AnimationAssistedTransfer">
                    <AnimatedPhone /> 
                </div>
                <div className="Data">
                    <p className="assistedTransferNumber">{this.props.phoneNumberTransfer}</p>
                    <p className="assistedTransferCalling">{this.language.getText("CallControlGUICallIOStatusmanualCall")}</p>
                    <div className="hangUpAssistedTransfer" onClick={()=>this.props.hangUpTransfer()}>{hangUp}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/CallingAssistedTransfer.jsx